module.exports = __webpack_public_path__ + "images/leaseabike_smalledb10248cea435f27e810403bdb18f5f.png";